<template>
  <div>
    <img class="enterprise__image" src="/static/images/logo-parkave-black.svg" alt="ParkAve" />
    <div class="enterprise__title">Account Quote Form</div>
    <div id="enterprise__form">
    </div>
  </div>
</template>

<script>
    export default {
      name: 'EnterpriseForm',
      mounted () {
        let formScript = document.createElement('script')
        formScript.setAttribute('src', '//js.hsforms.net/forms/shell.js');
        formScript.setAttribute('charset', 'utf-8');
        formScript.setAttribute('type', 'text/javascript');
        document.getElementById('enterprise__form').appendChild(formScript);
        setTimeout(() => {
          let formScript2 = document.createElement('script');
          formScript2.innerHTML = 'hbspt.forms.create({\n' +
            '        portalId: "2898305",\n' +
            '        formId: "a8e9721b-9b62-4eca-8201-ecf6fc059acd"\n' +
            '      });'
          document.getElementById('enterprise__form').appendChild(formScript2)
        }, 500);
      }
    }
</script>

<style type="text/scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/EnterpriseForm.vue